import {
  AllMenusQuery,
  BlogOrganisationTermsQuery,
  CategoryTermsQuery,
  ContentEventListAllPageQuery,
  EventCategoryTermsQuery,
  FieldOfExpertiseTermsQuery,
  IndustryTermsQuery,
  LatestEventsQuery,
  MedicalDomainTermsQuery,
  NewsEventTermsQuery,
  NewsTypeTermsQuery,
  OperationExecutorsProvider,
  OverlaysQuery,
  PageFeedbackSettingsQuery,
  ParaworkJobTypeTermsQuery,
  SettingsCallToActionQuery,
  SettingsNewsroomMediaRequestDetailsQuery,
  SettingsNewsroomUrlQuery,
  SettingsStorifyMeQuery,
  SettingsZsmFormsQuery,
  SiteMetadataQuery,
} from '@custom/schema';
import { Layout as UILayout } from '@custom/ui/routes/Layout';
import React, { ComponentProps, PropsWithChildren } from 'react';

import {
  useBlogOrganisationTermsQuery,
  useCategoryTermsQuery,
  useContentEventListAllPageQuery,
  useEventCategoryTermsQuery,
  useFieldOfExpertiseTermsQuery,
  useIndustryTermsQuery,
  useLatestEventsQuery,
  useMedicalDomainTermsQuery,
  useNewsEventsTermsQuery,
  useNewsTypesTermsQuery,
  useOverlaysQuery,
  useParaworkJobTypeTermsQuery,
  useSiteMenusQuery,
  useSiteMetadataQuery,
} from '../hooks';
import { useSettingsCallToActionQuery } from '../hooks/useSettingsCallToActionQuery';
import { useSettingsNewsroomMediaRequestDetailsQuery } from '../hooks/useSettingsNewsroomMediaRequestDetailsQuery';
import { useSettingsNewsroomUrlQuery } from '../hooks/useSettingsNewsroomUrl';
import { useSettingsPageFeedbackQuery } from '../hooks/useSettingsPageFeedbackQuery';
import { useSettingsStorifyMeQuery } from '../hooks/useSettingsStorifyMeQuery';
import { useSettingsZSMFormsQuery } from '../hooks/useSettingsZSMFormsQuery';
import { drupalExecutor } from '../utils/operation';

export function GlobalExecutors({ children }: PropsWithChildren) {
  const menus = useSiteMenusQuery();
  const overlays = useOverlaysQuery();
  const callToAction = useSettingsCallToActionQuery();

  return (
    <OperationExecutorsProvider
      executors={[
        {
          executor: drupalExecutor,
        },
        {
          id: AllMenusQuery,
          executor: menus,
        },
        {
          id: OverlaysQuery,
          executor: overlays,
        },
        {
          id: SettingsCallToActionQuery,
          executor: callToAction,
        },
        {
          id: IndustryTermsQuery,
          executor: useIndustryTermsQuery(),
        },
        {
          id: SiteMetadataQuery,
          executor: useSiteMetadataQuery(),
        },
        {
          id: NewsTypeTermsQuery,
          executor: useNewsTypesTermsQuery(),
        },
        {
          id: FieldOfExpertiseTermsQuery,
          executor: useFieldOfExpertiseTermsQuery(),
        },
        {
          id: BlogOrganisationTermsQuery,
          executor: useBlogOrganisationTermsQuery(),
        },
        {
          id: MedicalDomainTermsQuery,
          executor: useMedicalDomainTermsQuery(),
        },
        {
          id: EventCategoryTermsQuery,
          executor: useEventCategoryTermsQuery(),
        },
        {
          id: ContentEventListAllPageQuery,
          executor: useContentEventListAllPageQuery(),
        },
        {
          id: SettingsNewsroomMediaRequestDetailsQuery,
          executor: useSettingsNewsroomMediaRequestDetailsQuery(),
        },
        {
          id: SettingsCallToActionQuery,
          executor: useSettingsCallToActionQuery(),
        },
        {
          id: CategoryTermsQuery,
          executor: useCategoryTermsQuery(),
        },
        {
          id: LatestEventsQuery,
          executor: useLatestEventsQuery(),
        },
        {
          id: ParaworkJobTypeTermsQuery,
          executor: useParaworkJobTypeTermsQuery(),
        },
        {
          id: SettingsStorifyMeQuery,
          executor: useSettingsStorifyMeQuery(),
        },
        {
          id: SettingsZsmFormsQuery,
          executor: useSettingsZSMFormsQuery(),
        },
        {
          id: SettingsCallToActionQuery,
          executor: useSettingsCallToActionQuery(),
        },
        {
          id: SettingsNewsroomUrlQuery,
          executor: useSettingsNewsroomUrlQuery(),
        },
        {
          id: PageFeedbackSettingsQuery,
          executor: useSettingsPageFeedbackQuery(),
        },
        {
          id: NewsEventTermsQuery,
          executor: useNewsEventsTermsQuery(),
        },
      ]}
    >
      {children}
    </OperationExecutorsProvider>
  );
}

export const Layout: React.FC<ComponentProps<typeof UILayout>> = (props) => {
  return (
    <GlobalExecutors>
      <UILayout {...props} />
    </GlobalExecutors>
  );
};
